export default __webpack_public_path__ + "static/media/glasses_ar 1.5fa97d8b.png";